import { classnames } from '@/helpers';
import { ReactNode } from 'react';

const TITLE_CLASSNAMES: {
  [key in DataGridCellType]: string;
} = {
  default: 'text-md text-black-900',
  muted: 'text-md text-fg_primary',
  description: 'text-m text-fg_secondary',
  header: 'font-bold text-xl text-black-900',
  discount: 'text-highlight-700 text-md',
  positive: 'text-success text-md',
} as const;

type DataGridCellType = 'default' | 'muted' | 'description' | 'header' | 'discount' | 'positive';

const DataGridCell = ({
  leftIcon,
  title,
  type = 'default',
  rightIcon,
  align = 'left',
  ariaLabel = '',
  truncate,
  nowrap,
}: {
  leftIcon?: ReactNode;
  title: ReactNode | string;
  type?: DataGridCellType;
  rightIcon?: ReactNode;
  align?: 'left' | 'right';
  ariaLabel?: string;
  truncate?: boolean;
  nowrap?: boolean;
}) => {
  return (
    <div
      className={classnames('space-x-sm flex items-center', truncate ? 'flex-2' : 'flex-1')}
      role="gridcell"
      aria-label={ariaLabel}>
      {leftIcon && <div className="min-w-[24px] flex-shrink-0">{leftIcon}</div>}
      <span
        className={classnames(
          'flex-1 overflow-hidden',
          TITLE_CLASSNAMES[type],
          align !== 'left' && 'text-right',
          truncate && 'line-clamp-[1] flex-grow text-ellipsis',
          nowrap && 'whitespace-nowrap',
        )}>
        {title}
      </span>
      {rightIcon && <div className="flex-shrink-0">{rightIcon}</div>}
    </div>
  );
};

export default DataGridCell;
